/**
 * Normalizes a DCR-registered client name for display. Clients name their
 * connection after us (e.g. "Claude Code (medblocks)"); strip any trailing
 * parenthetical so the panel and consent screen read "Claude Code".
 */
export function displayClientName(raw: string | null | undefined): string {
  if (typeof raw !== "string" || raw.trim().length === 0) return "This app";
  return raw.replace(/\s*\([^)]*\)\s*$/, "").trim() || raw.trim();
}
